import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { SymbolFooterComponent } from "slotworks/components/footer/symbol-footer-component";
import { FooterComponent } from "../footer/footer-component";

export class SymbolFooterComponentFactory implements ComponentFactory {

    // TODO: This should be using SymbolFooterComponentConfig, but can't as it would be breaking
    /**
     * @param symbolScale The scale of the footer symbols, relative to the height of the footer text.
     * @param paddingX X padding for symbols (at percentage of symbol width) default 0.5
     * @param paddingY Y padding for symbols (at percentage of symbol height) default 0.5
     * @param singleSymbol Only show 1 symbol to represent a win instead of all symbols involved
     * @param validSymbols String list of ids which can be displayed - if not set will use all symbols in game definition
     * @param invalidSymbols String list of ids which cannot be displayed.
     */
    constructor(
        protected symbolScale: number = 1.2,
        protected paddingX: number = 0.5,
        protected paddingY: number = 0.5,
        protected singleSymbol: boolean = false,
        protected validSymbols?: string[],
        protected invalidSymbols?: string[],
        protected forceCreditMode?: boolean
    ) { }

    public build(): AbstractComponent {
        const footer = new FooterComponent({
            forceCreditMode: this.forceCreditMode
        });

        return footer;
    }
}
